import React from "react";
import "../../css/tp-hero.css";
import TPHeroImglg from "../../assets/images/teacherPage-hero-img-lg.png";
import TPHeroImgsm from "../../assets/images/teacherPage-hero-img-sm.png";

const Hero = () => {
  return (
    <section id="tp-hero">
      <div>
        <article>
          <h1>Expert courses for your children to pass their exams easily</h1>
          <p>
            We're different. Flex is the only saas business platform that lets
            you run your business on one platform, seamlessly across all digital
            channels.
          </p>
          <div>
            <a href="" /* eslint-disable-line jsx-a11y/anchor-is-valid  */>
              Get started
            </a>
            <a href="" /* eslint-disable-line jsx-a11y/anchor-is-valid */>
              Learn more
            </a>
          </div>
        </article>
        <figure id="tp-hero-img">
          <img id="tp-h-img-lg" src={TPHeroImglg} alt="" />
          <img id="tp-h-img-sm" src={TPHeroImgsm} alt="" />
        </figure>
      </div>
    </section>
  );
};

export default Hero;
